import { render, staticRenderFns } from "./InitializeOrderKidsExcelDialog.vue?vue&type=template&id=5bb67625&scoped=true"
import script from "./InitializeOrderKidsExcelDialog.vue?vue&type=script&lang=js"
export * from "./InitializeOrderKidsExcelDialog.vue?vue&type=script&lang=js"
import style0 from "./InitializeOrderKidsExcelDialog.vue?vue&type=style&index=0&id=5bb67625&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb67625",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bb67625')) {
      api.createRecord('5bb67625', component.options)
    } else {
      api.reload('5bb67625', component.options)
    }
    module.hot.accept("./InitializeOrderKidsExcelDialog.vue?vue&type=template&id=5bb67625&scoped=true", function () {
      api.rerender('5bb67625', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/TuitionManagement/dialog/InitializeOrderKidsExcelDialog.vue"
export default component.exports